import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatBottomSheetModule,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';

import { ProDirective } from './pro.directive';
import { I18nChild } from '@web-frontend/shared/i18n';
import { ProSelectDirective } from './pro-select.directive';
import {
  MAT_RADIO_DEFAULT_OPTIONS,
  MatRadioModule,
} from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { ModalTemplateModule } from '../modal-template';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LoadingModule } from '../loading';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProDisclaimerBannerComponent } from './pro-disclaimer-banner/pro-disclaimer-banner.component';
import { PeriodNameModule } from '@web-frontend/shared/pipes/period-name/period-name.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ManagePermissionComponent } from './manage-permission/manage-permission.component';
import {
  MatCheckboxDefaultOptions,
  MatCheckboxModule,
  MAT_CHECKBOX_DEFAULT_OPTIONS,
} from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProWarningInfoComponent } from './pro-warning-info/pro-warning-info.component';
import { PlatformDisableContentModule } from '../platform-disable-content/platform-disable-content.module';
import { TranslateModule } from '@ngx-translate/core';
import { BuyModalComponent } from './buy-modal/buy-modal.component';
import { BaseButtonModule } from '../../../common/components/button/baseButton.module';
import { PlansComponent } from './plans/plans.component';
import { PlanSelectionComponent } from './plan-selection/plan-selection.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { MatIconModule } from '@angular/material/icon';
import { IosActivationComponent } from './plans/ios-activation/ios-activation.component';
import { NoLoginRegisterModule } from '../../directives/no-login-register/no-login-register.module';
import { TrainingRequestComponent } from './training-request/training-request.component';
import { TrainingRequestService } from './training-request/training-request.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
    ProDirective,
    ProSelectDirective,
    ProDisclaimerBannerComponent,
    ManagePermissionComponent,
    ProWarningInfoComponent,
    BuyModalComponent,
    PlansComponent,
    PlanSelectionComponent,
    IosActivationComponent,
    ContactUsComponent,
    TrainingRequestComponent,
  ],
  imports: [
    CommonModule,
    I18nChild,
    MatRadioModule,
    FormsModule,
    MatDialogModule,
    ModalTemplateModule,
    LoadingModule,
    MatProgressSpinnerModule,
    PeriodNameModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatBottomSheetModule,
    PlatformDisableContentModule,
    TranslateModule.forChild(),
    BaseButtonModule,
    MatIconModule,
    MatSlideToggleModule,
    NoLoginRegisterModule,
  ],
  exports: [
    ProDirective,
    ProSelectDirective,
    ProDisclaimerBannerComponent,
    ManagePermissionComponent,
    ProWarningInfoComponent,
    BuyModalComponent,
    PlansComponent,
  ],
  providers: [
    {
      provide: MAT_RADIO_DEFAULT_OPTIONS,
      useValue: { color: 'accent' },
    },
    {
      provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
      useValue: { clickAction: 'noop' } as MatCheckboxDefaultOptions,
    },
    {
      provide: MatDialogRef,
      useValue: {},
    },
    {
      provide: MatBottomSheetRef,
      useValue: {},
    },
    TrainingRequestService,
  ],
})
export class PermissionsModule {}
